import axios from "axios";
import config from "../../../config";
import Cookies from "js-cookie";

const baseUrl = config.baseUrl; // URL base de tu API
const planesCompraEndpoint = "/api/financiero/planesdecomprasostenibilidad"; // Endpoint para consultar los planes de compra
const asignacionesSostenibilidad = "/api/financiero/asignacionesSostenibilidad"; // Endpoint para consultar los planes de compra

// Crear una instancia de Axios con la configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Función para listar todos los planes de compra
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const getPlanesCompraSostenibilidad = async () => {
  try {
    const response = await api.get(planesCompraEndpoint);
    return response.data; // Devuelve los datos del servicio
  } catch (error) {
    console.error(
      "Error al obtener los planes de compra sostenibilidad:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message:
        error.message || "Error al obtener los planes de compra sostenibilidad",
    };
  }
};

export const getAsignacionesSostenibilidad = async (proyectoOid) => {
  try {
    const url = proyectoOid
      ? `${asignacionesSostenibilidad}?proyecto_oid=${proyectoOid}`
      : asignacionesSostenibilidad;

    const response = await api.get(url);

    return response.data; // Devuelve los datos del servicio
  } catch (error) {
    console.error(
      "Error al obtener las asignaciones de sostenibilidad:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message:
        error.message || "Error al obtener las asignaciones de sostenibilidad",
    };
  }
};

export const getAsignacionesByIds = async (ids) => {
  try {
    const response = await api.post(`${asignacionesSostenibilidad}`, { ids });
    return response.data; // ✅ Devuelve el JSON de la API
  } catch (error) {
    console.error(
      "Error al obtener las asignaciones por ids:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al obtener las asignaciones por ids",
    };
  }
};

// Eliminar una asignacion  por OID
export const deleteAsignacionById = async (oid) => {
  try {
    const response = await api.delete(`${asignacionesSostenibilidad}/${oid}`);
    return response.data; // ✅ Devuelve la respuesta del backend
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al eliminar la asignación",
    };
  }
};

// ✅ Actualizar una asignación por OID
export const updateAsignacionById = async (
  oid,
  cantidad,
  oidStockLote,
  oidPlanItem
) => {
  try {
    const response = await api.put(`${asignacionesSostenibilidad}/${oid}`, {
      cantidad,
      oidStockLote,
      oidPlanItem,
    });
    return response.data; // ✅ Devuelve la respuesta del backend
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al actualizar la asignación",
    };
  }
};

/**
 * Función para obtener un plan de compra por ID
 */
export const getPlanCompraSostenibilidadById = async (id) => {
  try {
    const response = await api.get(`${planesCompraEndpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      `Error al obtener el plan de compra sostenibilidad con id ${id}:`,
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message:
        error.message ||
        `Error al obtener el plan de compra sostenibilidad con id ${id}`,
    };
  }
};

/**
 * Función para obtener la cantidad disponible de un producto PO
 */
export const getCounDisponibleProductPOById = async (id) => {
  try {
    const response = await api.get(
      `${asignacionesSostenibilidad}/disponibleCantidadPO/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error al obtener la  cantidad disponible:`,
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || `Error al obtener la cantidad disponible`,
    };
  }
};
